export default "__VITE_ASSET__Bj91YCrD__"